import Logo from './Logo.vue';

export default Logo;
